import { t, type LeftInZohoFile } from '@bms2/shared';
import { Icon } from '../../components/Icon';
import styles from './LeftInZohoFiles.module.css';

/**
 * 🔒 The files a record's Zoho Books source keeps there, which Zoho Books
 * offers no read of (decision 4805): each name, with Open in Zoho Books to the
 * record's own page there in a new tab, or the name alone where no address is
 * held. Drawn on a Quote under its files, or in place of the empty state, and
 * on a journal entry only where the list is not empty.
 */
export function LeftInZohoFiles({ files }: { files: readonly LeftInZohoFile[] }) {
  if (files.length === 0) return null;
  return (
    <div className={styles.left} data-left-in-zoho={files.length}>
      <p className={styles.title}>{t('import.leftInZoho.title')}</p>
      <p className={styles.hint}>{t('import.leftInZoho.hint')}</p>
      <ul className={styles.list}>
        {files.map((file, index) => (
          <li key={`${file.name}-${index}`} className={styles.file} data-left-in-zoho-file={file.name}>
            <span className={styles.name}>{file.name}</span>
            {file.url ? (
              <a className={styles.link} href={file.url} target="_blank" rel="noopener noreferrer" data-left-in-zoho-link={file.name}>
                {t('import.rejected.openInZoho')}
                <Icon meaning="externalLink" />
              </a>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
